import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-40f73f6e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "d-flex flex-row align-items-center"
};
var _hoisted_2 = {
  key: 0,
  class: "pe-2"
};
var _hoisted_3 = {
  class: "flex-fill d-flex flex-row pe-3"
};
var _hoisted_4 = {
  class: "name flex-fill"
};
var _hoisted_5 = {
  key: 0,
  class: "time d-flex flex-row align-items-center"
};
var _hoisted_6 = {
  class: "actions"
};
import { UseTimeAgo } from "@vueuse/components";
export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    avatar: null,
    avatarSize: {
      default: "medium"
    },
    time: null
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_n_avatar = _resolveComponent("n-avatar");

      var _component_n_text = _resolveComponent("n-text");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.avatar ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(), _createBlock(_component_n_avatar, {
            key: __props.avatar,
            size: __props.avatarSize,
            src: __props.avatar
          }, null, 8, ["size", "src"]))];
        }),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(), _createBlock(_component_n_text, {
            key: __props.name,
            strong: ""
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(__props.name), 1)];
            }),
            _: 1
          }))];
        }),
        _: 1
      })]), __props.time ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_unref(UseTimeAgo), {
        time: __props.time
      }, {
        default: _withCtx(function (_ref) {
          var timeAgo = _ref.timeAgo;
          return [_createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(), _createBlock(_component_n_text, {
                key: timeAgo,
                depth: "3"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("small", null, _toDisplayString(timeAgo), 1)];
                }),
                _: 2
              }, 1024))];
            }),
            _: 2
          }, 1024)];
        }),
        _: 1
      }, 8, ["time"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "actions")])]);
    };
  }
});